import React, { useState, useEffect } from 'react';
import type { FC, PropsWithChildren } from 'react';
import Select from 'react-select';
import { InputsSection, InputBox, ModalButtons, ModalForm, Modal, SelectBox, TextArea } from '../../../src/components/Modal';
import ModalHeading from '../../../src/components/Modal/ModalHeading';
import AddUserSkeleton from '../../../src/Skeletons/AddUserSkeleton';
import { IRTMTimeLogNew } from '../../hooks/rtm_time_log/index.type';
import { useAllPlan } from "../../hooks/planpatient";
import { Plan, IPlanRes } from "../../hooks/planpatient/index.type";

export type AddEditModalState = PropsWithChildren<{
    status: boolean;
    data?: IRTMTimeLogNew;
}>;

type SelectOption = {
    value: string;
    label: string;
};

export type IaddEditModalStates = PropsWithChildren<{
    description: { value: string; error: string };
    duration: { value: string; error: string };
    customDuration: { value: string; error: string };
}>;

type AddEditModalProps = PropsWithChildren<{
    loading: boolean;
    addEditModal: AddEditModalState;
    onCloseModal?: () => void;
    handleAddEdit?: (event: React.FormEvent<HTMLFormElement>) => void;
    addEditModalStates: IaddEditModalStates;
    setAddEditModalStates: React.Dispatch<React.SetStateAction<IaddEditModalStates>>;
}>;

const AddEditModal: FC<AddEditModalProps> = props => {
    const { planDataLoading, getPlanData } = useAllPlan();
    const [plans, setPlans] = useState<SelectOption[]>([]);

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const plansData = await getPlanData();
                if (plansData) {
                    const formattedPlans = plansData.map((plan: Plan) => ({
                        value: plan._id,
                        label: plan.name,
                    }));
                    setPlans(formattedPlans);
                }
            } catch (e) {
                console.error("Error fetching plans:", e);
            }
        }
        fetchPlans();
    }, []);
    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            width: '25rem',
            borderRadius: '1.3rem',
            minHeight: '2.5rem',
            boxShadow: '0px 4px 15px 5px rgba(0, 0, 0, 0.15)',
            backgroundColor: "#fff",
            padding: "2px 17px",
            fontSize: "14px",
        }),
        menu: (provided: any) => ({
            ...provided,
            width: '25rem',
        }),
        menuList: (provided: any) => ({
            ...provided,
            maxHeight: '15rem',
        }),
    };


    const handlePlanChange = (selectedOption: SelectOption | null) => {
        props.setAddEditModalStates(prevVal => ({
            ...prevVal,
            duration: {
                value: selectedOption ? selectedOption.value : '',
                error: ''
            }
        }));
    };


    const isCustomDuration = props.addEditModalStates.duration.value === 'Custom';

    return (
        <Modal show={props.addEditModal.status}>
            <ModalHeading heading={props.addEditModal.data && props.addEditModal.data._id ? 'Update Assign Plan' : 'Assign Plan'} />
            {props.loading ? (
                <AddUserSkeleton />
            ) : (
                <ModalForm style={{ marginBottom: '2.5rem' }} onSubmit={props.handleAddEdit}>
                    <InputsSection>
                        <div>
                            <label
                                htmlFor="plan-select"
                                style={{ color: '#0f407a',fontSize:"1.2rem",marginBottom:"1rem" }}
                            >
                                Select Plan
                            </label>
                            <Select
                                id="plan-select"
                                options={plans}
                                onChange={handlePlanChange}
                                placeholder="Select Plan"
                                styles={customStyles}
                                isSearchable={true}
                                noOptionsMessage={() => "No plans found"}
                            />
                        </div>
                    </InputsSection>

                    <InputsSection>
                        <InputBox
                            label='Select Date'
                            placeholder='Assign Date'
                            type='date'
                            value=""
                        // name='dob'
                        />
                    </InputsSection>

                    <ModalButtons
                        submitButtonLabel={props.addEditModal.data && props.addEditModal.data._id ? 'Update' : 'Select'}
                        cancelButtonLabel='Cancel'
                        onCancel={props.onCloseModal}
                    />
                </ModalForm>
            )}
        </Modal>
    );
};

export default AddEditModal;